import { RunState, getStatus, getTopologyState } from "@/store/flowsheet/flowsheet.slice"
import { memo, useEffect, useMemo } from "react"
import { useSelector } from "react-redux"
import { StreamsUpdatePlugin } from "./StreamsUpdatePlugin"
import { NodeSimUpdate } from "./NodeSimUpdate"
import { useReactState } from "../../hooks/useReactState"
import { EventMap, getEventBusInstance } from "../../events/useEventBusInstance"


export const UnitSimUpdatePlugin = memo(() => {
  const topology = useSelector(getTopologyState)
  const runState = useSelector(getStatus)
  const rerenderState = useReactState(0)

  useEffect(() => {
    const eventBus = getEventBusInstance()
    const handler = () => {
      rerenderState.setValue(rerenderState.value + 1)
    }
    eventBus.on(EventMap.lineJumpNodeAdded, handler);
    return () => {
      eventBus.off(EventMap.lineJumpNodeAdded, handler);
    }
  }, [rerenderState])

  const cellMap = useMemo(() => {
    const cells = topology?.operations || [];
    return cells.reduce((res, cur) => {
      res[cur.uuid] = cur;
      return res;
    }, {})
  }, [topology, rerenderState])

  if (runState !== RunState.Run) return;
  
  return <>
    <StreamsUpdatePlugin cellMap={cellMap} />
    <NodeSimUpdate cellMap={cellMap} />
  </>;
})